/**
 * 询报价统一表单接口（InquiryGeneralControllerV2）。
 * 询价管理继续使用 inquiry-unified.ts，不要改那边的地址。
 */
import { request } from '@/utils/http'
import type { InquiryUnifiedDetail, InquiryUnifiedSaveRequest } from './inquiry-unified'

export type { InquiryUnifiedDetail, InquiryUnifiedSaveRequest }

export interface InquirySubmitRequest {
  businessType: string
  inquiryId: number | string
  /** 1-商务 2-供应商 */
  inquiryTarget: number
  clientQuoterId?: number | string | null
  contactList?: unknown[] | null
}

/** 询报价统一表单获取询价详情 */
export const getUnifiedInquiry = (businessType: string, params: { id: number | string }) => {
  return request.post<InquiryUnifiedDetail>(
    `/price/inquiry/general/v2/unified/get?businessType=${encodeURIComponent(businessType)}`,
    params
  )
}

/** 询报价统一表单新增询价 */
export const saveUnifiedInquiry = (params: InquiryUnifiedSaveRequest) => {
  return request.post<number>('/price/inquiry/general/v2/unified/save', params)
}

/** 询报价统一表单修改询价 */
export const updateUnifiedInquiry = (params: InquiryUnifiedSaveRequest) => {
  return request.post<boolean>('/price/inquiry/general/v2/unified/update', params)
}

/** 提交询价（向商务询价 / 向供应商询价） */
export const submitUnifiedInquiry = (params: InquirySubmitRequest) => {
  return request.post<boolean>('/price/inquiry/general/v2/submit', params)
}
